import styled from 'styled-components/';
import AppCSS from '../../../../../utils/styled';

export const Components = {
  DayTileWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5px;
    margin-top: 8px;
  `,
  DotsWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 5px;
  `,
  Dot: styled.div<{ variant: string }>`
    width: 5px;
    height: 5px;
    ${AppCSS.radiuses.forHeight(5)};
    background-color: ${({ variant }) => {
      switch (variant) {
        case 'hasDailyAlux':
          return AppCSS.colors.blue;
      }
    }};
  `,
};
